import { useMutation } from 'react-query';
import AuthAxios from 'utils/authAxios';
import { dataApiUrl } from 'utils/url';

const DataApiUrl = dataApiUrl();

export function useDeliverDistroQueueEntry(options = {}) {
  return useMutation(async (mutationOptions = {}) => {
    const { assetReleaseDistributionQueueId } = mutationOptions;
    return await AuthAxios.post(`${DataApiUrl}/distributions/queue/${assetReleaseDistributionQueueId}/deliver`);
  }, options);
}
